import { DatePipe } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

const getLocalDateTime = (date: any, format = 'short') => {
    return new DatePipe('en-US')
        .transform(date, format);
};
export const ENV: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
const userProfile: BehaviorSubject<any> = new BehaviorSubject<any>(null);

export const loadingMessage: BehaviorSubject<string> = new BehaviorSubject<string>('');
const DEFAULT_ENV = 'QA';

/**
 * Get and sets environment using config.json endpoint exposed through nginx.conf
 */
export const setEnv = (location = window.location) => {
    if (location.href.includes('localhost')) {
        ENV.next(DEFAULT_ENV);
    } else {
        const url = `assets/config.json`;

        const http = new XMLHttpRequest();
        http.open('GET', url);
        http.send();
        http.onreadystatechange = (e) => {
            if (http.readyState === XMLHttpRequest.DONE &&
                http.status === 200) {
                const response = JSON.parse(http.responseText);
                if (response?.env && !response.env.includes("#")) {
                    ENV.next(response.env);
                }
            }
        };
    }
};

export const getEnv = () => ENV.value;

export const utilities = {
    getEnv,
    getLocalDateTime
};


export const getUserProfile = (): any => {
    return userProfile.value;
};

export const setUserProfile = (profile): any => {
    return userProfile.next(profile);
};


export const flatten = filter => {
    const filters = (filter || {}).filters;
    if (filters) {
        return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
    }
    return [];
};
